var React = require('react');

function IconWarningO (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M535.8 755.2h-45.5c-5.5 0-10-4.5-10-10v-61.5c0-5.5 4.5-10 10-10h45.5c5.5 0 10 4.5 10 10v61.5c0 5.5-4.5 10-10 10zM535.8 623.1h-44.5c-5.5 0-10-4.5-10-10V470.2c0-5.5 4.5-10 10-10h44.5c5.5 0 10 4.5 10 10v142.9c0 5.5-4.5 10-10 10z","key":0}),React.createElement("path",{"d":"M504.3 142.4L73.7 886.3c-3.9 6.7 1 15 8.7 15h861.3c7.7 0 12.5-8.3 8.7-15L521.7 142.4c-3.9-6.6-13.5-6.6-17.4 0zm8.7 104.7l347.4 593.8H171.8L513 247.1z","key":1})]);
}

IconWarningO.displayName = "IconWarningO";

IconWarningO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconWarningO;

IconWarningO.default = IconWarningO;
